import { create } from 'zustand';

interface Toast {
  id: string;
  message: string;
  duration: number;
  timeoutId?: NodeJS.Timeout; // 타이머 ID를 저장
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, duration?: number, limitCount?: number) => void;
  removeToast: (id: string) => void;
}

const useToastStore = create<ToastState>(set => ({
  toasts: [],
  addToast: (message: string, duration: number = 1500, limitCount = 1) => {
    const id = Math.random().toString(36).substr(2, 9);

    // 설정한 토스트 갯수를 초과하면 더 이상 추가하지 않음
    if (useToastStore.getState().toasts.length >= limitCount) {
      return;
    }

    const timeoutId = setTimeout(() => {
      set((state: ToastState) => ({
        toasts: state.toasts.filter(toast => toast.id !== id),
      }));
    }, duration);

    set((state: ToastState) => ({
      toasts: [...state.toasts, { id, message, duration, timeoutId }],
    }));
  },
  removeToast: (id: string) => {
    set((state: ToastState) => {
      const toast = state.toasts.find(toast => toast.id === id);
      if (toast && toast.timeoutId) {
        clearTimeout(toast.timeoutId); // 타이머를 제거하여 메모리 누수 방지
      }
      return {
        toasts: state.toasts.filter(toast => toast.id !== id),
      };
    });
  },
}));

export default useToastStore;
